export default __webpack_public_path__ + "static/media/kubota-m7171-premium-kvt.b59f1abc.jpg";